
export const BASE_URL = "https://vapi.v2nportal.com";
